import ReservationService from '~/services/ReservationService';

import { reservationQueryKeys } from './reservationQueryKeys';
import { RoomRateInfo, useGroupedByRoomRate } from './useGroupedByRoomRate';

export function useGetExtraGuestSurchargesByRoomRate(
  propertyId: string,
  selectedRoomRates: Array<RoomRateInfo>,
  enabled: boolean,
) {
  return useGroupedByRoomRate<App.ExtraGuestSurcharges>(
    reservationQueryKeys.extraGuestSurchargesByRoomRate(
      propertyId,
      selectedRoomRates.map((rr) => rr.roomRate.id),
    ),
    propertyId,
    selectedRoomRates,
    enabled,
    async (property, roomType, roomRate) => {
      const extraGuestSurchargesResponse = await ReservationService.getExtraGuestSurcharges(
        property,
        roomType,
        roomRate,
      );
      return extraGuestSurchargesResponse.result?.surcharges ?? [];
    },
  );
}
